import { render } from "./AddVpcOffering.vue?vue&type=template&id=03a50458&scoped=true"
import script from "./AddVpcOffering.vue?vue&type=script&lang=js"
export * from "./AddVpcOffering.vue?vue&type=script&lang=js"

import "./AddVpcOffering.vue?vue&type=style&index=0&id=03a50458&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a50458"]])

export default __exports__